import { connect } from 'react-redux';
import downloadPdfActions from 'store/downloadPdf/actions';
import PaymentConfirmationNew from 'pages/PaymentConfirmationNew';

const mapStateToProps = state => {
  return {
    isPDFDownloading: state.downloadPdf.isPDFDownloading,
    eSignedData: state.signUp.signData,
  };
};
const mapDispatchToProps = {
  loadMembershipAgreementPDF:
    downloadPdfActions.Creators.loadMembershipAgreementPDFRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentConfirmationNew);
